import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '' }) => {
  return (
    <Link to="/" className={`flex items-center group ${className}`}>
      <img
        src="/logo.svg"
        alt="Clik Technologies"
        style={{ height: '54px', width: 'auto' }}
        className="transition-transform group-hover:scale-[1.02]"
      />
    </Link>
  );
};

export default Logo;
